var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDiamond = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28781 1.31472e-05C5.18446 0.00935406 5.08479 0.0553716 5.01062 0.127951L0.127855 4.89687C-0.0426183 5.06553 -0.0426183 5.37495 0.127855 5.54362L9.68017 14.8753C9.84833 15.0416 10.1517 15.0416 10.3198 14.8753L19.8722 5.54362C20.0426 5.37495 20.0426 5.06553 19.8722 4.89687L14.9894 0.127951C14.9047 0.0460785 14.7873 -0.000902762 14.6696 1.31472e-05C11.5433 1.31472e-05 8.411 1.31472e-05 5.28781 1.31472e-05ZM5.51525 0.909742H6.42499L4.05113 4.77604H1.55644L5.51525 0.909742ZM7.4911 0.909742H9.54513V4.77604H5.12434L7.4911 0.909742ZM10.4549 0.909742H12.5089L14.8757 4.77604H10.4549V0.909742ZM13.575 0.909742H14.4848L18.4436 4.77604H15.9489L13.575 0.909742ZM1.57776 5.68576H4.06534L7.94597 11.9117L1.57776 5.68576ZM5.13145 5.68576H9.54513V12.7645L5.13145 5.68576ZM10.4549 5.68576H14.8686L10.4549 12.7645V5.68576ZM15.9347 5.68576H18.4222L12.054 11.9117L15.9347 5.68576Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDiamond, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Diamond.4a6bee17.svg";
export { ForwardRef as ReactComponent };